import React, { useState, useEffect } from 'react'
import parentsideStyle from './SideBar.module.css'
import { Sidenav, Nav } from 'rsuite';
import { MdDashboard } from "react-icons/md";
import { FaCalendarAlt } from "react-icons/fa";
import { ImBooks } from "react-icons/im";
import { FaShoppingBasket } from "react-icons/fa";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../../../context/CartContext';
import { useMediaQuery } from 'react-responsive';
import { FiChevronDown } from "react-icons/fi";

export default function SideBar({ eventId }) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [event, setEvent] = useState(null);
  const [eventAuthors, setEventAuthors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { cart, removeFromCart, updateQuantity } = useCart();
  const [total, setTotal] = useState(0);
  const [totalitem, setTotalItem] = useState(0);
  const location = useLocation();
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/' ? parentsideStyle.active : '';
    }
    // For account/profile, check if the current path starts with /user-profile
    if (path === '/user-profile') {
      return location.pathname.startsWith('/user-profile') ? parentsideStyle.active : '';
    }
    return location.pathname === path ? parentsideStyle.active : '';
  };

  // Get event data from localStorage if available
  useEffect(() => {
    const storedEvent = localStorage.getItem('currentEvent');
    const storedAuthors = localStorage.getItem('currentEventAuthors');

    if (storedEvent && storedAuthors) {
      setEvent(JSON.parse(storedEvent));
      setEventAuthors(JSON.parse(storedAuthors));
    }
  }, []);

  useEffect(() => {
    const newTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    setTotal(newTotal);
    const item = cart.length;
    setTotalItem(item);
  }, [cart]);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        if (!eventId) return;

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_events.php?id=${eventId}`);

        if (!response.ok) {
          throw new Error('Failed to fetch event');
        }

        const data = await response.json();

        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const options = { month: 'long', day: '2-digit' };
          return date.toLocaleDateString('en-GB', options);
        };

        if (data.success && Array.isArray(data.events) && data.events.length > 0) {
          const event = data.events[0];
          const startDateFormatted = formatDate(event.event_start_date);
          const endDateFormatted = formatDate(event.event_end_date);
          const eventDateRange = `${startDateFormatted} - ${endDateFormatted}`;

          // Parse book_data and extract authors
          let authors = [];
          try {
            if (event.book_data && typeof event.book_data === 'string') {
              const bookData = JSON.parse(event.book_data);
              if (Array.isArray(bookData)) {
                // Group books by author
                const authorMap = new Map();

                bookData.forEach(book => {
                  const authorId = book.authorBookDataAdded?.[0]?.author_id || book.authorId;
                  const authorName = book.authorName;

                  if (!authorMap.has(authorId)) {
                    authorMap.set(authorId, {
                      author_id: authorId,
                      f_name: authorName.split(' ')[0],
                      l_name: authorName.split(' ').slice(1).join(' '),
                      books: []
                    });
                  }

                  // Add all books for this author
                  if (Array.isArray(book.authorBookDataAdded)) {
                    book.authorBookDataAdded.forEach(bookData => {
                      // Log the book data structure for debugging
                      //console.log('Book data structure:', bookData);

                      // Extract book details from the correct structure
                      const bookDetails = {
                        book_id: bookData.book_id || bookData.id,
                        title: bookData.title || bookData.book_title,
                        price: bookData.price || bookData.book_price,
                        format: bookData.format || bookData.book_format || 'Paperback'
                      };

                      // Only add if we have the required fields
                      if (bookDetails.book_id && bookDetails.title && bookDetails.price) {
                        authorMap.get(authorId).books.push(bookDetails);
                      }
                    });
                  }
                });

                authors = Array.from(authorMap.values());
              }
            }
          } catch (error) {
            console.error("Error parsing book_data:", error);
          }

          const updatedEvent = { ...event, event_date_range: eventDateRange };
          setEvent(updatedEvent);
          setEventAuthors(authors);

          // Store in localStorage
          localStorage.setItem('currentEvent', JSON.stringify(updatedEvent));
          localStorage.setItem('currentEventAuthors', JSON.stringify(authors));
          localStorage.setItem('currentEventId', eventId);
        } else {
          throw new Error('Invalid event data');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [eventId]);

  const [open, setOpen] = useState(null);

  return (
    <>
      <div className={parentsideStyle.sidebar}>
        <ul className={parentsideStyle.menu}>
          <Link to="" className={parentsideStyle.parentsidebarAchor}>
            <li className={`${parentsideStyle.item} ${parentsideStyle.active} ${isActive('/')} `}>
              <MdDashboard className={`${parentsideStyle.parentsideIcon} rs-icon me-2`} />
              <span>Dashboard</span>
            </li></Link>
          <li className={parentsideStyle.item}>
            <div className={parentsideStyle.dropHeader} onClick={() => setOpen(open === "events" ? null : "events")}>
              <FaCalendarAlt className={`${parentsideStyle.parentsideIcon} rs-icon`} />
              <span>Events</span>
              <span className={`${parentsideStyle.arrow} ${open === "events" ? parentsideStyle.rotate : ""}`}>
                <FiChevronDown className={`${parentsideStyle.arrow} ${open === "events" ? parentsideStyle.rotate : ""}`} />
              </span>
            </div>
            {open === "events" && (
              <ul className={parentsideStyle.submenu}>
                {event ? (
                  <Link to={`/ParentsViewPage/${btoa(event.tbl_event_id)}`} className={parentsideStyle.parentsidebarAchor}>
                    <li key={event.tbl_event_id} eventKey={event.tbl_event_id} className={isActive(`/ParentsViewPage/${event.tbl_event_id}`)} > {event.event_date_range} </li></Link>

                ) : (
                  <span>No event available</span>
                )}
              </ul>
            )}
          </li>
          <li className={parentsideStyle.item}>
            <div className={parentsideStyle.dropHeader} onClick={() => setOpen(open === "books" ? null : "books")}>
              <ImBooks className={`${parentsideStyle.parentsideIcon} rs-icon`} />
              <span>Books</span>
              <span className={`${parentsideStyle.arrow} ${open === "books" ? parentsideStyle.rotate : ""}`}>
                <FiChevronDown className={`${parentsideStyle.arrow} ${open === "events" ? parentsideStyle.rotate : ""}`} />
              </span>
            </div>
            {open === "books" && (
              <ul className={parentsideStyle.submenu}>
                {eventAuthors && Array.isArray(eventAuthors) && eventAuthors.length > 0 ? (
                  eventAuthors.map(author => (

                    <li key={author.author_id} eventKey={author.author_id} className={isActive(`/ParentsBook/${author.author_id}`)}
                    ><Link
                      to={`/ParentsBook/${author.author_id}`}
                      className={parentsideStyle.parentsidebarAchor}
                      onClick={() => {
                        // Log the author's books before storing
                        // console.log('Author books before storing:', author.books);

                        if (author.books && author.books.length > 0) {
                          localStorage.setItem('selectedAuthor', `${author.f_name} ${author.l_name}`);
                          localStorage.setItem('authorBooks', JSON.stringify(author.books));
                          localStorage.setItem('currentEventId', eventId);
                        } else {
                          console.error('No valid books found for author:', author);
                        }
                      }}
                    >{author.f_name} {author.l_name} </Link></li>
                  ))
                ) : (
                  <span>No Author available</span>
                )}
              </ul>
            )}
          </li>
          <Link to="/ParentsCheckout" ><li className={`${parentsideStyle.item} ${isActive('/ParentsCheckout')}`} >
            <FaShoppingBasket className={`${parentsideStyle.parentsideIcon} rs-icon me-2`} />
            <span>Cart ({totalitem})</span>
          </li></Link>
        </ul>
      </div>

    </>
  );
}
